<table class="table table-sm table-hover">
  <thead>
  <tr>
    <th>host</th>
    <th>buildTimestamp</th>
    <th>commitId</th>
    <th>time</th>
    <th>javaClassVersion</th>
    <th>javaSpecificationVersion</th>
    <th>osName</th>
    <th>osVersion</th>
    <th>javaRuntimeVersion</th>
    <th>javaVendor</th>
    <th>actions</th>
  </tr>
  </thead>
  <tbody>
    @for (host of hosts; track host.host) {
      <tr>
        <td>{{host.host}}</td>
        <td>{{host.buildTimestamp}}</td>
        <td>{{host.commitId}} ({{host.commitsBehind}} behind)</td>
        <td>{{host.time}}</td>
        <td>{{host.javaClassVersion}}</td>
        <td>{{host.javaSpecificationVersion}}</td>
        <td>{{host.osName}}</td>
        <td>{{host.osVersion}}</td>
        <td>{{host.javaRuntimeVersion}}</td>
        <td>{{host.javaVendor}}</td>
        <td>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeDummy(host.host)">dummy</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeShutdown(host.host)">shutdown</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeBash(host.host)">bash</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeSpel(host.host)">spel</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeCmd(host.host)">cmd</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executePowershell(host.host)">powershell</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeQwen(host.host)">qwen</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeAi(host.host)">ai</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeStartScreenshotStream(host.host)">sss</button>
          <button type="button" class="btn btn-sm btn-primary" (click)="executeEndScreenshotStream(host.host)">sse</button>
        </td>
      </tr>
    }
  </tbody>
</table>
<textarea [(ngModel)]="text" style="width: 100%" type="text" class="form-control"></textarea>
<hr>
@for (customAction of customActions; track customAction.description) {
  <button type="button" class="btn btn-sm btn-primary" (click)="executeCustomAction(customAction)">{{customAction.description}}</button>
}

<hr>
<h3>Responses</h3>
<table class="table table-sm table-hover">
  <thead>
  <tr>
    <th>metadata</th>
    <th>content (stdout/response)</th>
  </tr>
  </thead>
  <tbody>
  @for (resp of responses; track resp.id) {
    <tr (click)="resp.id && toggleExpand(resp.id)" style="cursor: pointer">
      <td class="metadata-cell">
        <div class="metadata-item"><span class="label">ID:</span> {{resp.id}}</div>
        <div class="metadata-item"><span class="label">Type:</span> {{resp.type}}</div>
        <div class="metadata-item"><span class="label">Created:</span> {{resp.responseEntityCreated | date:'yyyy-MM-dd HH:mm:ss'}}</div>
        <div class="metadata-item"><span class="label">UID:</span> {{resp.stracliCommandUid}}</div>
      </td>
      <td class="content-cell">
        @let parsed = getParsed(resp);
        <div class="scroll-container">
          @if (parsed) {
            @switch (resp.type) {
              @case (StracliCommandType.BASH) { <pre>{{parsed.stdout || parsed.stderr || 'No output'}}</pre> }
              @case (StracliCommandType.CMD) { <pre>{{parsed.stdout || parsed.stderr || 'No output'}}</pre> }
              @case (StracliCommandType.POWERSHELL) { <pre>{{parsed.stdout || parsed.stderr || 'No output'}}</pre> }
              @case (StracliCommandType.QWEN) { <pre>{{parsed.stdout || parsed.stderr || 'No output'}}</pre> }
              @case (StracliCommandType.AI) {
                <div class="ai-badges">
                  <span class="badge" [class.bg-success]="parsed.exitCode === 0" [class.bg-danger]="parsed.exitCode !== 0">Exit: {{parsed.exitCode}}</span>
                  @if (parsed.pushSuccess != null) {
                    <span class="badge ms-1" [class.bg-success]="parsed.pushSuccess" [class.bg-danger]="!parsed.pushSuccess">Push: {{parsed.pushSuccess ? 'ok' : 'failed'}}</span>
                  }
                  @if (parsed.gitDiff) { <span class="badge bg-info text-dark ms-1">has diff</span> }
                  @if (parsed.stderr) { <span class="badge bg-warning text-dark ms-1">stderr</span> }
                </div>
                @if (parsed.stdout) {
                  <div class="ai-text">{{parsed.stdout}}</div>
                }
                @if (parsed.stderr) {
                  <div class="ai-text ai-stderr" [class.mt-2]="parsed.stdout">{{parsed.stderr}}</div>
                }
                @if (!parsed.stdout && !parsed.stderr) {
                  <div class="ai-text text-muted">No output</div>
                }
              }
              @case (StracliCommandType.SPEL) { <pre>{{parsed.responseString || parsed.responseJson}}</pre> }
              @case (StracliCommandType.START_SCREENSHOT_STREAM) { <pre>streaming: {{parsed.streaming}}, screen available: {{parsed.screenAvailable}}, interval: {{parsed.intervalMillis}} ms</pre> }
              @case (StracliCommandType.END_SCREENSHOT_STREAM) { <pre>streaming: {{parsed.streaming}}, screen available: {{parsed.screenAvailable}}</pre> }
              @default { <pre>{{resp.response.typeSpecificResponse}}</pre> }
            }
          } @else {
            <pre>{{resp.response.typeSpecificResponse}}</pre>
          }
        </div>
      </td>
    </tr>
    @if (resp.id && isExpanded(resp.id)) {
      <tr>
        <td colspan="2">
          <div style="background-color: #f8f9fa; padding: 15px; border-radius: 4px; border: 1px solid #dee2e6;">
            @let parsed = getParsed(resp);
            @if (parsed) {
              <div class="row">
                @if (resp.type === StracliCommandType.BASH || resp.type === StracliCommandType.CMD || resp.type === StracliCommandType.POWERSHELL || resp.type === StracliCommandType.QWEN) {
                  <div class="col-md-3"><strong>Exit Code:</strong> {{parsed.exitCode}}</div>
                  <div class="col-md-3"><strong>Terminated:</strong> {{parsed.terminatedOnItsOwn}}</div>
                  <div class="col-12 mt-2">
                    <strong>Stdout:</strong>
                    <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{parsed.stdout}}</pre>
                  </div>
                  <div class="col-12 mt-2">
                    <strong>Stderr:</strong>
                    <pre style="background: white; padding: 5px; border: 1px solid #eee; color: red;">{{parsed.stderr}}</pre>
                  </div>
                } @else if (resp.type === StracliCommandType.AI) {
                  <div class="col-12">
                    <span class="badge" [class.bg-success]="parsed.exitCode === 0" [class.bg-danger]="parsed.exitCode !== 0">Exit code: {{parsed.exitCode}}</span>
                    <span class="badge bg-secondary ms-1">Terminated on its own: {{parsed.terminatedOnItsOwn}}</span>
                    @if (parsed.pushSuccess != null) {
                      <span class="badge ms-1" [class.bg-success]="parsed.pushSuccess" [class.bg-danger]="!parsed.pushSuccess">Push: {{parsed.pushSuccess ? 'ok' : 'failed'}}</span>
                    }
                  </div>
                  <div class="col-12 mt-2">
                    <strong>Output:</strong>
                    <div class="ai-output">{{parsed.stdout || '(empty)'}}</div>
                  </div>
                  @if (parsed.stderr) {
                    <div class="col-12 mt-2">
                      <strong>Stderr:</strong>
                      <pre style="background: white; padding: 5px; border: 1px solid #eee; color: red;">{{parsed.stderr}}</pre>
                    </div>
                  }
                  @if (parsed.gitStatus) {
                    <div class="col-12 mt-2">
                      <strong>Git status:</strong>
                      <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{parsed.gitStatus}}</pre>
                    </div>
                  }
                  @if (parsed.gitDiff) {
                    <div class="col-12 mt-2">
                      <strong>Git diff:</strong>
                      <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{parsed.gitDiff}}</pre>
                    </div>
                  }
                  <div class="col-12 mt-2">
                    <details>
                      <summary class="text-muted" style="cursor: pointer">Raw JSON</summary>
                      <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{resp.response.typeSpecificResponse}}</pre>
                    </details>
                  </div>
                } @else if (resp.type === StracliCommandType.SPEL) {
                  <div class="col-12">
                    <strong>Response String:</strong>
                    <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{parsed.responseString}}</pre>
                  </div>
                  <div class="col-12 mt-2">
                    <strong>Response JSON:</strong>
                    <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{parsed.responseJson}}</pre>
                  </div>
                } @else {
                  <div class="col-12">
                    <strong>Raw JSON:</strong>
                    <pre style="background: white; padding: 5px; border: 1px solid #eee;">{{resp.response.typeSpecificResponse}}</pre>
                  </div>
                }
              </div>
            } @else {
              <strong>Raw Data:</strong>
              <pre>{{resp.response.typeSpecificResponse}}</pre>
            }
            <div class="mt-3 text-muted" style="font-size: 0.8rem">
              <div><strong>Command UID:</strong> {{resp.response.uid}}</div>
              <div><strong>Sent:</strong> {{resp.response.cmdSent | date:'yyyy-MM-dd HH:mm:ss.SSS'}}</div>
              <div><strong>Received:</strong> {{resp.response.cmdReceived | date:'yyyy-MM-dd HH:mm:ss.SSS'}}</div>
              <div><strong>Performed:</strong> {{resp.response.cmdPerformed | date:'yyyy-MM-dd HH:mm:ss.SSS'}}</div>
            </div>
          </div>
        </td>
      </tr>
    }
  }
  </tbody>
</table>
